import styles from '@/components/FloatButton/index.less';
import { FC } from 'react';
interface IStickyActiveButtonProps {
  //操作按钮文字
  activeText: string;
  //点击事件
  activeClick: () => void;
}

const StickyActiveButton: FC<IStickyActiveButtonProps> = (props) => {
  const { activeText, activeClick } = props;
  return (
    <div className={styles.container}>
      <div onClick={activeClick}>{activeText}</div>
    </div>
  );
};

export default StickyActiveButton;
